import moment from 'moment';
import {Request} from 'common/domain/models/request';
import {HR_ERRORS} from 'common/domain/constants.errors';
import {MODALS} from 'common/domain/constants';
import {STATES} from 'common/domain/states';
import {isUndefinedOrNullOrEmpty} from 'common/utils/isUndefinedOrNullOrEmpty';
import Swipe from 'common/utils/swipe';
import TeamRequestCardHelper from './teamRequestCard.helper';

class TeamRequestCardController {
  constructor
  ($log,
   $location,
   teamRequestsService,
   vacationUserDataService,
   inceptionService,
   vacationDelegationService,
   $timeout,
   loadingMobileService) {
    'ngInject';
    this.log = $log;
    this.teamRequestsService = teamRequestsService;
    this.inceptionService = inceptionService;
    this.managerId = vacationUserDataService.getEmployee().userId;
    this.vacationDelegationService = vacationDelegationService;
    this.timeout = $timeout;
    this.teamRequestCardHelper = new TeamRequestCardHelper();
    this.loadingMobileService = loadingMobileService;
  }

  $onInit() {
    this.urlDestination = STATES.VACATIONS_ABSENCES.DELEGATE;
    this._initImage();
    this._initAvailableDays();
    this._initStatus();
    this._initRequestDate();
    this._initResetApproveModal();
    this.request.typeText = Request.getTranslation(this.request.type);
    this.request.statusText = this._getStatusText();
    this.endDate = angular.copy(this.request.endDate);

    this._disableInceptionInCoincidencesIfHasDelegations();
  }

  $postLink() {
    if (this.shouldSwipe()) {
      this.initSwipe();
    }
  }

  get modalWarningDelegation() {
    const $modal = $(MODALS.WARNING_DELEGATION_MODAL);
    return $modal;
  }

  shouldSwipe() {
    const isRejectAccept = this.teamRequestCardHelper.isRejectAccept(this.request);
    const isDiscard = this.teamRequestCardHelper.isDiscard(this.request);
    return this.isMobileApp && (isRejectAccept || isDiscard);
  }

  initSwipe() {
    this.timeout(() => {
      const swiper = new Swipe(this.getCardSelector());
      swiper.onLeft(event => this.onSwipeLeft(event));
      swiper.onRight(event => this.onSwipeRight(event));
      swiper.run();
    });
  }

  onSwipeRight() {
    this.timeout(() => {
      this.swiped = false;
    });
  }

  onSwipeLeft() {
    this.timeout(() => {
      this.swiped = true;
    });
  }

  getCardSelector() {
    return `team-request-card .${this.cardId}`;
  }

  getCardClass() {
    let cardClassList = [this.request.type];

    if (this.isMobileApp) {
      cardClassList.push('responsiveMobile');
    }

    if (this.swiped) {
      cardClassList.push('swiped');

      if (this.teamRequestCardHelper.isDiscard(this.request)) {
        cardClassList.push('discard');
      }
    }

    return cardClassList;
  }

  _getStatusText() {
    if (this.request.status !== Request.STATUS_REQUESTED.APPROVE) {
      return Request.getTranslation(this.request.status);
    }
  }

  _initImage() {
    if (this.request.image === HR_ERRORS.NOT_AVAILABLE) {
      delete this.request.image;
    }
  }

  _initAvailableDays() {
    if (this.request.availableDays === HR_ERRORS.NOT_EXISTS) {
      this.request.availableDays = HR_ERRORS.DEFAULT_VISIBLE_TEXT;
    }
  }

  _initStatus() {
    const HR_HAS_INCONSISTENT_STATUS = this.request.status === 'without status';
    if (HR_HAS_INCONSISTENT_STATUS) {
      this.request.status = HR_ERRORS.DEFAULT_VISIBLE_TEXT;
      return;
    }

    const HR_HAS_INCONGRUENT_VACATIONS_DISCARD = this.request.type === Request.TYPES.VACATION && this.request.status === Request.STATUS_REQUESTED.DISCARD;
    if (HR_HAS_INCONGRUENT_VACATIONS_DISCARD) {
      this.request.status = HR_ERRORS.DEFAULT_VISIBLE_TEXT;
      return;
    }
  }

  _initRequestDate() {
    if (isUndefinedOrNullOrEmpty(this.request.requestDate)) {
      this.request.requestDate = HR_ERRORS.DEFAULT_VISIBLE_TEXT;
    }
  }

  inceptEmployee(employeeId) {
    this._getDelegations().then(() => {
      if (this.hasDelegated) {
        return this._showModalWarningDelegation();
      }

      this.inceptionService.incept(employeeId, 'team-requests');
    });
  }

  _getDelegations() {
    const today = moment().format('YYYY-MM-DD');
    return this.vacationDelegationService.hasDelegated(this.managerId).then(response => {
      this.hasDelegated = response.hasDelegated;
      if (this.hasDelegated) {
        this.delegation = this.vacationDelegationService.findDelegationActive(today, response.delegations);
      }
    });
  }

  _showModalWarningDelegation() {
    this.modalWarningDelegation.modal('show');
  }

  _disableInceptionInCoincidencesIfHasDelegations() {
    this._getDelegations().then(() => {
      this.isDisabledInceptionByDelegation = this.hasDelegated;
    });
  }

  accept() {
    this.loadingMobileService.show();

    this
      .teamRequestsService.approve(this.managerId, this.request)
      .then(() => {
        this.log.info('TeamRequestCardController accept()', this.request);
        this._showModalAcceptSuccess();
      })
      .catch((error) => {
        this.log.error('TeamRequestCardController approve():', this.managerId, this.request, error);
        this._showModalAcceptError(error);
      })
      .finally(() => this.loadingMobileService.hide());
  }

  _showModalAcceptSuccess() {
    this.showSuccess = true;
    this._getApproveModal().modal('show');
  }

  _showModalAcceptError(error) {
    this.error = error;
    this._getApproveModal().modal('show');
  }

  _initResetApproveModal() {
    this._getApproveModal().on('hidden.bs.modal', () => {
      this.showSuccess = null;
      this.error = null;
    });
  }

  _getApproveModal() {
    return $(`${MODALS.TEAM_REQUESTS.APPROVE}${this.modalId}`);
  }

  reject() {
    this.log.info('reject()', this.request, 'show confirm modal ...');
    this.withDelegation ? this.confirmReject() : this._getRemoveModal().modal('show');
  }

  confirmReject() {
    this.loadingMobileService.show();

    this
      .teamRequestsService.reject(this.managerId, this.request)
      .then(() => {
        this.rejectCardSuccess = true;
      })
      .catch((error) => {
        this.rejectCardError = error;
        this._getRemoveModal().modal('show');
      })
      .finally(() => this.loadingMobileService.hide());
  }

  _getRemoveModal() {
    return $(`${MODALS.TEAM_REQUESTS.REMOVE}${this.modalId}`);
  }

  discard() {
    this.loadingMobileService.show();

    this
      .teamRequestsService.discard(this.managerId, this.request)
      .then(() => {
        this.log.info('TeamRequestCardController discard()', this.managerId, this.request);
        this.onDiscard();
      })
      .catch((error) => {
        this.log.error('TeamRequestCardController discard():', this.managerId, this.request, error);
        this._showModalAcceptError(error);
      })
      .finally(() => this.loadingMobileService.hide());
  }

  existEndDate() {
    return !!this.endDate;
  }
}

export default TeamRequestCardController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCard.controller.js